/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialSystemFilter = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      d="M6.897 13.073v1.063c0 .121.063.234.166.3l1.5.937a.352.352 0 0 0 .541-.3v-2H6.897zm7.103-10v-2a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v2c0 .15.086.25.176.367l4.721 5.664v2.97h2.207v-2.97l4.72-5.664c.082-.114.176-.216.176-.366"
      fill="currentColor"
    />
  </svg>
);

IconSocialSystemFilter.displayName = 'IconSocialSystemFilter';

IconSocialSystemFilter.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialSystemFilter);
IconSocialSystemFilter.displayName = 'IconSocialSystemFilter';
